import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class RoleView {
	readonly id: number;
	readonly name: string;
	readonly label: string;
	readonly description: string | null;
	readonly isSystem: boolean;
	readonly isActive: boolean;
	readonly permissions: readonly string[];
	readonly assignedUserCount: number;

	constructor(payload: RolePayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.label = payload.label;
		this.description = payload.description;
		this.isSystem = payload.isSystem;
		this.isActive = payload.isActive;
		this.permissions = payload.permissions;
		this.assignedUserCount = payload.assignedUserCount;

		Object.freeze(this);
	}

	hasPermission(permission: string): boolean {
		return this.permissions.includes(permission);
	}
}

export default RoleView;
